import React, {useMemo} from 'react';
import {InputSlider} from 'components';
import {suffixRemove} from 'utils';
import {useEditorStyle} from 'hooks';
import type {IChildrenProps} from './Editor.Inspector';

interface IEditorInspectorPaddingProps extends IChildrenProps {}

const EditorInspectorPadding = ({style, setProp}: IEditorInspectorPaddingProps) => {
  const values = useMemo(() => {
    const paddings = style?.padding as string | undefined;
    const paddingValues = paddings ? paddings.split(' ') : ['0', '0', '0', '0'];
    return paddingValues.map(v => suffixRemove('px', v));
  }, [style?.padding]);

  const {updateStyle} = useEditorStyle({setProp});

  return (
    <div>
      <h4 className="font-medium text-sm text-slate-800 dark:text-white pb-4">Padding</h4>
      <div className="flex flex-col gap-3">
        {['Top', 'Right', 'Bottom', 'Left'].map((side, index) => {
          return (
            <InputSlider
              key={side}
              label={side}
              suffix="px"
              defaultValue={values[index]}
              onSlide={value => {
                values[index] = value;
                updateStyle('padding', values.map(v => `${v}px`).join(' '));
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(EditorInspectorPadding);
